import parse from 'html-react-parser';

export function parseTextToHtml(text) {
  return parse(text);
}

